const createSuspensionClockEvent = () => [
  { action: "copyEvent", value: "card", type: "to" },
  { action: "newEvent", value: null, type: "main" },
  {
    action: "saveData",
    value: "clock",
    type: "class",
  },
  {
    action: "saveData",
    value: "suspension",
    type: "eventType",
  },
  {
    action: "saveData",
    value: "adjust",
    type: "subType",
  },
  {
    action: "saveData",
    value: [{ option: "value", value: "2" }],
    type: "options",
  },
  { action: "sendEvent", value: "new", type: "main" },
  { action: "copyEvent", value: "card-clock", type: "to" },
  { action: "copyEvent", value: "card", type: "from" },
];

const startSuspensionClockEvent = (srcEvent) => [
  { action: "copyEvent", value: srcEvent, type: "to" },
  { action: "copyEvent", value: "card-clock", type: "from" },
  { action: "copyData", value: "personId", type: srcEvent },
  { action: "sendEvent", value: "edit", type: "main" },
  { action: "newEventId", value: null, type: "main" },
  {
    action: "saveData",
    value: "start",
    type: "subType",
  },
  {
    action: "clearData",
    value: ["options"],
    type: "main",
  },
  { action: "sendEvent", value: "new", type: "main" },
  { action: "copyEvent", value: srcEvent, type: "from" },
];

const createTwoMinuteSuspension = (value) => [
  {
    actions: [
      { action: "copyEvent", value: "penalty-suspension", type: "to" },
      { action: "copyEvent", value: value, type: "from" },
      { action: "copyData", value: "personId", type: "penalty-suspension" },
      { action: "sendEvent", value: "edit", type: "main" },
      { action: "copyEvent", value: value, type: "to" },
    ],
    conditions: [
      {
        item: "eventDefined",
        value: value,
        operator: "is",
      },
    ],
  }
];

export const PenaltySuspensionPlayer = {
  name: "penalty-suspension-player",
  component: "MainPanel",
  layout: "main-panel large",
  mode: "visible",
  text: "penalty.suspension.select-player",
  showOn: [
    {
      state: "primary",
      value: "penalty-suspension-player",
      operator: "is",
    }],
  allowFlag: true,
  allowCancel: true,
  allowCancelPlay: true,
  cancelActions: [
    {
      actions: [{ action: "clearAllEvents" }],
      conditions: [],
    },
  ],
  showDetails: { events: ["main"] },
  allowBack: { value: "useHistory" },
  children: [
    {
      name: "pre-action",
      component: "PreAction",
      layout: "pre-action",
      mode: "enable",
      text: "",
      showOn: [true],
      startEvent: false,
      startPlay: false,
      actionGroups: [
        {
          actions: [
            { action: "copyEvent", value: "penalty-suspension", type: "from" }
          ],
          conditions: [],
        },
      ],
    },
    {
      name: "penalty-suspension-player-select",
      component: "PlayerSelect",
      layout: "player-select",
      mode: "visible",
      startEvent: false,
      startPlay: false,
      showOn: [true],
      options: {
        currentEntity: true,
        showBench: false,
        showCoach: true,
      },
      actionGroups: [
        ...createTwoMinuteSuspension("penalty-suspension-two-min-1"),
        ...createTwoMinuteSuspension("penalty-suspension-two-min-2"),
        {
          actions: [
            { action: "deleteFromPlay", value: "redCard", type: "main" },
          ],
          conditions: [
            {
              item: "eventType",
              value: "suspension",
              event: "main",
              operator: "is",
            },
          ],
        },
        {
          actions: [
            { action: "copyEvent", value: "penalty-suspension", type: "to" },
            { action: "newEvent", value: null, type: "main" },
            { action: "saveData", value: "redCard", type: "eventType" },
            { action: "sendEvent", value: "new", type: "main" },
            { action: "copyEvent", value: "penalty-suspension", type: "from" },
          ],
          conditions: [
            {
              item: "eventCountForPerson",
              eventType: "suspension",
              count: 2,
              event: "main",
            },
            {
              item: "eventType",
              value: "suspension",
              event: "main",
              operator: "is",
            },
          ],
        },

/* YELLOW CARD */
        {
          actions: [
            { action: "deleteFromPlay", value: "redCard", type: "main" },
            { action: "deleteFromPlay", value: "suspension", type: "main", class: "sport", options: ["all"] },
            { action: "deleteFromPlay", value: "suspension", type: "main", class: "clock", options: ["all"] },
          ],
          conditions: [
            {
              item: "eventType",
              value: "yellowCard",
              event: "main",
              operator: "is",
            },
          ],
        },
        {
          actions: [
            { action: "copyEvent", value: "card", type: "to" },
            { action: "newEvent", value: null, type: "main" },
            { action: "saveData", value: "redCard", type: "eventType" },
            { action: "sendEvent", value: "new", type: "main" },
            { action: "newEvent", value: null, type: "main" },
            { action: "saveData", value: "suspension", type: "eventType" },
            { action: "saveData", value: "twoMinutes", type: "subType" },
            { action: "sendEvent", value: "new", type: "main" },
            { action: "copyEvent", value: "card", type: "from" },
            ...createSuspensionClockEvent(),
            ...startSuspensionClockEvent("card"),
            { action: "copyEvent", value: "card", type: "from" },
          ],
          conditions: [
            {
              item: "eventCountForPerson",
              eventType: "yellowCard",
              count: 1,
              event: "main",
              options: ["ignoreMain"],
            },
            {
              item: "eventType",
              value: "yellowCard",
              event: "main",
              operator: "is",
            },
          ],
        },

/* RED CARD */
        {
          actions: [
            ...createSuspensionClockEvent(),
            ...startSuspensionClockEvent("card")
          ],
          conditions: [
            {
              item: "eventType",
              value: "redCard",
              event: "main",
              operator: "is",
            },
          ],
        },
        {
          actions: [
            ...startSuspensionClockEvent("penalty-suspension")
          ],
          conditions: [
            {
              item: "eventType",
              value: "suspension",
              event: "main",
              operator: "is",
            },
          ],
        },
        {
          actions: [
            { action: "sendEvent", value: "edit", type: "main" },
            { action: "copyEvent", value: "penalty-suspension", type: "to" },
            { action: "copyEvent", value: "penalty-shot", type: "from" },
            {
              action: "nextState",
              value: "penalty-change-goal-keeper",
              type: "primary",
            },
          ],
          conditions: [],
        },
      ],
    },
    {
      name: "confirm-later-penalty-suspension-player-select",
      component: "ButtonPanel",
      layout: "button-group centered",
      mode: "visible",
      showOn: [true],
      children: [
        {
          name: "confirm-later",
          component: "TypeButton",
          layout: "match-button",
          mode: "enable",
          text: "confirmLater",
          showOn: [true],
          startEvent: false,
          startPlay: false,
          actionGroups: [
            {
              actions: [
                { action: "sendEvent", value: "edit", type: "main" },
                { action: "copyEvent", value: "penalty-suspension-player", type: "to" },
                { action: "copyEvent", value: "penalty", type: "from" },
                {
                  action: "nextState",
                  value: "penalty-change-goal-keeper",
                  type: "primary",
                },
              ],
            },
          ],
        },
      ],
    },
  ],
};
